import { Textarea } from '@/components/ui/textarea';
import { cn } from '@/lib/utils';

export interface FeedbackCommentFieldProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  maxLength?: number;
  disabled?: boolean;
  required?: boolean;
  className?: string;
}

export function FeedbackCommentField({
  value,
  onChange,
  placeholder = 'Add a comment (optional)',
  maxLength = 5000,
  disabled = false,
  required = false,
  className,
}: FeedbackCommentFieldProps) {
  return (
    <div className={cn('space-y-1', className)}>
      <Textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        maxLength={maxLength}
        disabled={disabled}
        required={required}
        rows={3}
      />
      <div className="flex justify-end text-xs text-muted-foreground">
        {value.length} / {maxLength}
      </div>
    </div>
  );
}
